"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PHONE_NUMBER_FORMAT = /^1?[2-9][0-9]{9}$/;
var NOT_DIGIT = /[^0-9]/g;
function normalizePhoneNumber(phoneNumber) {
    try {
        var trimmed = phoneNumber.replace(NOT_DIGIT, '');
        if (!PHONE_NUMBER_FORMAT.test(trimmed)) {
            return null;
        }
        if (trimmed.length === 10) {
            return "+1" + trimmed;
        }
        return "+" + trimmed;
    }
    catch (_a) {
        return null;
    }
}
exports.normalizePhoneNumber = normalizePhoneNumber;
//# sourceMappingURL=index.js.map